/**
 * UI range DatePicker ↔ listQuery.filters（API：`repair_date_from`／`repair_date_to`）。
 */
import { formatApiDateRangeDisplay } from '#/utils/date';

export function readRepairDateRangeFilter(filters = {}) {
  const from = filters.repairDateFrom;
  const to = filters.repairDateTo;

  if (!from && !to) {
    return undefined;
  }

  return {
    from: from ?? '',
    to: to ?? from ?? '',
  };
}

export function applyRepairDateRangeToFilters(filters = {}, range) {
  const next = { ...filters };

  if (!range?.from && !range?.to) {
    delete next.repairDateFrom;
    delete next.repairDateTo;
    return next;
  }

  const from = range.from;
  const to = range.to || range.from;

  next.repairDateFrom = from || undefined;
  next.repairDateTo = to || undefined;

  return next;
}

export function resolveRepairDateFilterChipDisplay(_values, ctx = {}) {
  const display = formatApiDateRangeDisplay({
    from: ctx.filters?.repairDateFrom,
    to: ctx.filters?.repairDateTo,
  });

  return display ? [display] : [];
}
